export interface Category {
  name: string;
  slug: string;
  description: string;
  icon: string;
  count: number;
}

export const categories: Category[] = [
  {
    name: '网红塌房',
    slug: 'wanghong-tafang',
    description: '网红人设崩塌、翻车现场、反差视频全收录',
    icon: 'ri-user-line',
    count: 128,
  },
  {
    name: '明星八卦',
    slug: 'mingxing-bagua',
    description: '娱乐圈最新八卦、恋情曝光、明星动态',
    icon: 'ri-star-line',
    count: 256,
  },
  {
    name: '独家爆料',
    slug: 'dujia-baoliao',
    description: '独家内幕消息、行业黑料、第一手资讯',
    icon: 'ri-fire-line',
    count: 89,
  },
  {
    name: '社会热点',
    slug: 'shehui-redian',
    description: '社会热点事件追踪、民生话题深度报道',
    icon: 'ri-global-line',
    count: 312,
  },
  {
    name: '综艺节目',
    slug: 'zongyi-jiemu',
    description: '综艺节目争议、选手八卦、幕后故事',
    icon: 'ri-tv-line',
    count: 167,
  },
  {
    name: '直播翻车',
    slug: 'zhibo-fanche',
    description: '直播带货翻车、主播失误、名场面合集',
    icon: 'ri-live-line',
    count: 94,
  },
];